"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Span = void 0;

var _tokens = require("@superlogica/foundation/tokens");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _HelperText = _interopRequireDefault(require("./HelperText.theme"));

var Span = _styledComponents.default.span.withConfig({
  componentId: "sc-1kj1d7o-0"
})(["width:100%;display:block;overflow:hidden;padding-left:0px;padding-right:0px;transition:0.2s all linear;font-size:12px;line-height:1.2;", ""], function (_ref) {
  var theme = _ref.theme,
      status = _ref.status,
      floating = _ref.floating;
  var color = (0, _HelperText.default)(theme.colors);
  return (0, _styledComponents.css)(["position:", ";bottom:", ";margin-top:", "px;font-size:", "px;font-weight:", ";letter-spacing:", "px;line-height:", "px;height:", "px;font-family:", ",sans-serif;color:", ";"], floating ? 'absolute' : 'relative', floating ? "-".concat(theme.typography.subtitle01.desktop.lineHeight + _tokens.spacing.vertical.xxxxs, "px") : 'auto', floating ? 0 : _tokens.spacing.vertical.xxxxs, theme.typography.subtitle01.desktop.fontSize, theme.typography.subtitle01.desktop.fontWeight, theme.typography.subtitle01.desktop.letterSpacing, theme.typography.subtitle01.desktop.lineHeight, theme.typography.subtitle01.desktop.lineHeight, theme.fonts.default, color[status]);
});

exports.Span = Span;